import * as request from "../utils/request"

export function initMidas() {
  return new Promise((resolve, reject) => {
    if (window.Midas) {
      resolve(window.Midas)
    } else {
      request
        .getScript("//midas.gtimg.cn/h5pay/js/api/midas.js")
        .then(() => {
          resolve(window.Midas)
        })
        .catch(error => {
          reject(error)
        })
    }
  })
}
